import {
  ExamCenterLocationList,
  ExamLocationSearchFilter,
} from '@exam-center/exam-location-management';
import { APP_PERMISSIONS } from '@exam-center/permission';
import { Flex, PaperSection } from '@shared/components';
import { PermissionGuard } from '@shared/permissions';

export default function PermissionRequiredExamLocationManagementLocationsPage() {
  return (
    <PermissionGuard
      requiredPermission={[APP_PERMISSIONS.EXAM_LOCATION_MANAGEMENT.EXAM_LOCATION.VIEW]}
    >
      <ExamLocationManagementLocationsPage />
    </PermissionGuard>
  );
}

function ExamLocationManagementLocationsPage() {
  return (
    <PaperSection title='สถานที่สอบทั้งหมด'>
      <Flex
        sx={(theme) => ({ p: theme.spacing(4), flexDirection: 'column', gap: theme.spacing(4) })}
      >
        <ExamLocationSearchFilter />
        <ExamCenterLocationList />
      </Flex>
    </PaperSection>
  );
}
